import { render, staticRenderFns } from "./CharacterBuilderEquipment.vue?vue&type=template&id=1caeaaec&lang=pug&"
import script from "./CharacterBuilderEquipment.vue?vue&type=script&lang=ts&"
export * from "./CharacterBuilderEquipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports